import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContentWrapper from "../../../Wrapper";
import * as accountWalletActions from "../../store/actions/account_wallet_actions";
import { ContentWithCardLoading } from "../../../../components/loading";
import AccountDetailsSubheader from "../../components/account-details-subheader";
import { BlueGradientButton } from "../../../../components/button";
import { Card, Col, Form, Row } from "react-bootstrap";
import { CustomModal } from "../../../../components/modal";
import { useParams } from "react-router-dom";

const WALLET_ACTIONS = {
  NONE: "NONE",
  ADD_BALANCE: "ADD_BALANCE",
  DEDUCT_BALANCE: "DEDUCT_BALANCE",
};

export default function AccountWallet({ match }) {
  const tabName = "Wallet";
  const accountWallet = useSelector((state) => state.accounts.accountWallet);
  const [walletAction, setWalletAction] = useState(WALLET_ACTIONS.NONE);
  const billingDetailsEntries = accountWallet.billingDetails ? Object.entries(accountWallet.billingDetails) : [];

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(accountWalletActions.getWalletInfoRequest({ id: match.params.accountId }));
    dispatch(accountWalletActions.getAccountBillingDetailsRequest({ id: match.params.accountId }));
  }, [dispatch, match.params.accountId]);

  return (
    <ContentWrapper
      subHeader={
        <AccountDetailsSubheader active={tabName}>
          <div className="d-flex align-items-center gap-4">
            <BlueGradientButton size="sm" onClick={() => setWalletAction(WALLET_ACTIONS.ADD_BALANCE)}>
              Add Balance
            </BlueGradientButton>
            <BlueGradientButton size="sm" onClick={() => setWalletAction(WALLET_ACTIONS.DEDUCT_BALANCE)}>
              Deduct balance
            </BlueGradientButton>
          </div>
        </AccountDetailsSubheader>
      }
    >
      <div className="card w-100">
        <div className="card-body">
          {accountWallet.loading|| !accountWallet.data ? (
            <ContentWithCardLoading />
          ) : (
            <>
              <div className={`notice d-flex align-items-center mb-6 mt-4 `}>
                <div className="d-flex flex-stack flex-grow-1 fw-bold">
                  <div className="d-flex gap-6 align-items-center">
                    <h4 className="text-gray-900 fw-bolder m-0 ">
                      Account Balance:{" "}
                      <span style={{ color: "#3699FF" }}>
                        {accountWallet.data?.currency} {accountWallet.data?.balance}
                      </span>
                    </h4>
                  </div>
                </div>
              </div>
              <Card className="p-8 mb-8">
                <Row>
                  <Col xs={6}>
                    <div className="mb-lg-10 pr-4">
                      <div className="d-flex text-muted fw-bolder fs-5 mb-3">
                        <span className="flex-grow-1 text-gray-800">Low Credit Notification: {accountWallet.data?.walletAutoNotify?.isNotify ? "On" : "Off"}</span>
                      </div>
                      <div className="mb-2">
                        {accountWallet.data?.walletAutoNotify?.emails.map((email) => (
                          <div>{email}</div>
                        ))}
                      </div>
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div className=" pl-4">
                      <div className="d-flex text-muted fw-bolder fs-5 mb-3">
                        <span className="flex-grow-1 text-gray-800">
                          Low Credit Threshold: {accountWallet.data?.walletAutoNotify?.lowBalance === undefined ? "not defined" : `${accountWallet.data?.walletAutoNotify?.lowBalance} ${accountWallet.data?.currency}`}
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>

              <div className="notice d-flex align-items-center mb-6 mt-4">
                <div className="d-flex flex-stack flex-grow-1 fw-bold">
                  <div className="d-flex gap-6 align-items-center">
                    <h4 className="text-gray-900 fw-bolder m-0">
                      Account Billing Details
                    </h4>
                  </div>
                </div>
              </div>

              <Card className="p-4 mb-8">
                <Row>
                  {billingDetailsEntries.map(([key, value], index) => (
                    <React.Fragment key={index}>
                      {index % 2 === 0 && index !== 0 && <Col xs={12} className="mb-3"></Col>} {/* Adds a new row every two entries */}
                      <Col xs={6} className="mb-3">
                        <Row>
                          <Col xs={12} className={index % 2 === 0 ? "fw-bold" : ""}>
                            <strong>{key.toUpperCase()} </strong>{" "}: {" "}{value}
                          </Col>
                        </Row>
                      </Col>
                    </React.Fragment>
                  ))}
                </Row>
              </Card>
            </>
          )}
        </div>
      </div>
      <AccountWalletModal
        show={walletAction === WALLET_ACTIONS.ADD_BALANCE || walletAction === WALLET_ACTIONS.DEDUCT_BALANCE}
        action={walletAction}
        allWalletActions={WALLET_ACTIONS}
        handleClose={() => setWalletAction(WALLET_ACTIONS.NONE)}
      />
    </ContentWrapper>
  );
}

const AccountWalletModal = ({ show, action, allWalletActions, handleClose }) => {
  const [inputValue, setInputValue] = useState(0);
  const dispatch = useDispatch();
  const params = useParams();

  const addBalanceModalProps = {
    title: "Add Balance",
    buttonText: "Add Balance",
    handleAccept: () => handleSubmit("add"),
  };

  const deductBalanceModalProps = {
    title: "Deduct Balance",
    buttonText: "Deduct Balance",
    handleAccept: () => handleSubmit("deduct"),
  };

  const handleModalClose = () => {
    setInputValue(0);
    handleClose();
  };
  const handleSubmit = (type) => {
    const payload = {
      loadingData: {
        id: params.accountId,
      },
      data: { accountId: params.accountId, balance: inputValue },
    };

    if (type === "add") {
      dispatch(accountWalletActions.addWalletBalanceRequest(payload));
    }

    if (type === "deduct") {
      dispatch(accountWalletActions.deductWalletBalanceRequest(payload));
    }
    handleModalClose();
  };

  const modalProps = action === allWalletActions.ADD_BALANCE ? addBalanceModalProps : action === allWalletActions.DEDUCT_BALANCE ? deductBalanceModalProps : {};

  return (
    <CustomModal
      modalProps={{
        show,
        handleClose: handleModalClose,
        ...modalProps,
      }}
    >
      <Form.Control type="number" value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
    </CustomModal>
  );
};
